"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _defaults = _interopRequireDefault(require("lodash/defaults"));

function useDefaults(obj) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }

  return (0, _react.useMemo)(function () {
    return _defaults.default.apply(void 0, [obj].concat(sources));
  }, [obj, sources]);
}

var _default = useDefaults;
exports.default = _default;